<template>
    <section class="carousel-slice">
        <Swiper :modules="MODULES" :navigation="true" :centered-slides="true">
            <SwiperSlide v-for="(item, index) in slice.items" :key="index" class="item">
                <PrismicImage :field="item.image" />
            </SwiperSlide>
        </Swiper>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicImage} from '@prismicio/vue';
    import type {CarouselSlice} from '@prismicio-types';
    // @ts-expect-error - swiper has no types
    import {Navigation} from 'swiper';
    import {Swiper, SwiperSlide} from 'swiper/vue';
    import 'swiper/css';
    import 'swiper/css/navigation';
    defineProps({
        ...getSliceComponentProps<CarouselSlice>(),
    });
    const MODULES = [Navigation];
</script>
<style lang="scss">
    @use '~/assets/styles/variables' as *;
    .carousel-slice {
        margin-top: 80px;
        margin-bottom: 80px;
        @include content-width($article-max-width);

        .swiper-wrapper {
            align-items: center;
        }
        .swiper-button-prev,
        .swiper-button-next {
            content: url('~/assets/svg/arrowRight.svg');
            padding: var(--joy-core-spacing-3);
            border-radius: var(--joy-core-radius-6);
            height: 42px;
            width: 42px;
            background-color: var(--joy-color-primary-50);
        }
        .swiper-button-prev {
            transform: rotate(180deg);
        }
        .swiper {
            @media (max-width: $mobile-breakpoint) {
                padding-bottom: 70px;
                .swiper-wrapper {
                    align-items: flex-end;
                }
                .swiper-button-prev,
                .swiper-button-next {
                    position: absolute;
                    top: unset;
                    bottom: 10px;
                    left: unset;
                    right: 0;
                }
                .swiper-button-prev {
                    left: unset;
                    right: 60px;
                }
            }
        }
        .item {
            height: 100%;
            img {
                width: 100%;
                height: auto;
            }
        }
    }
</style>
